import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";

@Component({
  selector: "app-cancellation-master",
  templateUrl: "./cancellation-master.component.html",
  styleUrls: ["./cancellation-master.component.css"]
})
export class CancellationMasterComponent implements OnInit {
  actionmode: string = "Seacrh";
  showList: boolean = false;
  screen_details: any = [];
  searchlist: boolean = false;
  startrangeflag: boolean = true;
  endrangeflag: boolean = true;
  chargeflag: boolean = true;
  nameflag: boolean = true;

  editFlag: any = false;
  screentitle: string = "Cancellation Master";
  search_details: any = [];
  viewpage = false;
  searchresult = false;
  searchtabledata: any = [];
  loader: any = false;
  parent_table = "cancellation_band";

  childtables = [];
  EditData: any = [];
  filters = [];
  CabinClasses: any = ["B", "E"];
  delete_id="";
  constructor(private vernostService: VernostServiceService) { }

  ngOnInit() { }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
  }

  searchForm() {
    this.actionmode = "Search";
    this.screen_details = [];
    this.editFlag = false;
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    // this.search_details = [];
    this.searchData();
  }
  submitcancelData() {
    // console.log("this.screen_details", this.screen_details);
    if (
      this.screen_details.Start_Range == "" ||
      this.screen_details.Start_Range == undefined ||
      this.screen_details.End_Range == "" ||
      this.screen_details.End_Range == undefined
      //  ||
      // this.screen_details.Cabin_Class == undefined ||
      // this.screen_details.Cabin_Class == ""
       ||
      this.screen_details.Cancellation_Charge == undefined ||
      this.screen_details.Cancellation_Charge == ""
      ||
     this.screen_details.Band_Name == undefined ||
     this.screen_details.Band_Name == ""
    ) {
      // document.getElementById("errs").innerHTML = 
      this.showMessagePopup("Please fill all data");
    } else {
      let id;
      if (this.EditData.length > 0) {
        id = this.EditData[0]["BUCKET_ID"];
      }
      //ID: this.EditData[0]["BUCKET_ID"];
      var CANArray = {
        ID: id,
        StartRange: this.screen_details.Start_Range,
        EndRange: this.screen_details.End_Range,
        CancellationCharge: this.screen_details.Cancellation_Charge,
        BandName: this.screen_details.Band_Name
        // ,CabinClass: this.screen_details.Cabin_Class
      };

      if (this.editFlag == false) {

        this.vernostService.InsertCancelArray(CANArray).subscribe(response => {
          console.log("CancellationResponce:-", response);
          if (response != undefined) {
            // document.getElementById("errs").innerHTML = 
            this.showMessagePopup("Record Inserted Successfully");
            this.screen_details = [];
          } else {
            // document.getElementById("errs").innerHTML = 
            this.showMessagePopup("Record Not Inserted Successfully");
          }

        });
      }
      if (this.editFlag == true) {

        console.log("EditData=" + this.EditData[0]["BUCKET_ID"]);
        console.log("this.EditData=" + JSON.stringify(this.EditData));
        this.vernostService.UpdateCancelArray(CANArray).subscribe(response => {
          console.log("CancelUpdate:-", response);
          if (response != undefined) {
            // document.getElementById("errs").innerHTML = 
            this.showMessagePopup("Record Updated Successfully")
            this.screen_details = [];
          } else {
            // document.getElementById("errs").innerHTML = 
            this.showMessagePopup("Record Not Updated Successfully")
          }

        });
      }
    }
  }

  searchData() {

    this.searchlist = false;
    this.loader = true;

    let fieldOne = this.search_details.Start_Range;
    let fieldTwo = this.search_details.End_Range;
    let fieldThree = this.search_details.Cabin_Class;
    let fieldFour = this.search_details.Bucket_Name;
    if (
      (fieldOne == "" || fieldOne == undefined) &&
      (fieldTwo == "" || fieldTwo == undefined) &&
      (fieldThree == "" || fieldThree == undefined) &&
      (fieldFour == "" || fieldFour == undefined)
    ) {
      this.loader = false;
      this.showMessagePopup("Please apply filter to search");
      this.searchresult = false;
    } else {
      if (fieldOne != undefined && fieldOne.trim() != "") {

        var fields1 = fieldOne.toUpperCase();
      }
      if (fieldTwo != undefined && fieldTwo.trim() != "") {
        var fields2 = fieldTwo.toUpperCase();
      }
      let searchItem = [];
      var searchColumn = [];
      if (fieldOne != "" && fieldOne != undefined) {
        searchItem.push(fields1);
        searchColumn.push("START_RANGE");
      }
      if (fieldTwo != "" && fieldTwo != undefined) {
        searchItem.push(fields2);
        searchColumn.push("END_RANGE");
      }
      if (fieldThree != "" && fieldThree != undefined) {
        searchItem.push(fieldThree);
        searchColumn.push("CABIN_CLASS");
      }
      if (fieldFour != "" && fieldFour != undefined) {
        searchItem.push(fieldFour);
        searchColumn.push("BAND_NAME");
      }
      var data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchItem,
        childtables: this.childtables,
        filters: this.filters
      };

      this.vernostService.searchRecord(data).subscribe(res => {
        this.loader = false;
        this.searchtabledata = res;
        if (res.length > 0) {
          this.searchresult = true;
          this.searchtabledata = res;
          document.getElementById("errs").innerHTML = "";


        } else {
          this.searchresult = false;
          this.showMessagePopup("Record not found");
        }
      });
    }
  }

  showFormData(data, flag) {
    this.EditData = [];
    this.EditData.push(data);

    if (flag == 1) {
      this.editFlag = false;

      this.actionmode = "view";
      this.viewpage = true;


    } else {
      this.editFlag = true;
      this.delete_id = data.BUCKET_ID;

      this.actionmode = "Edit";
      this.screen_details.Start_Range = data.START_RANGE;
      this.screen_details.End_Range = data.END_RANGE;
      this.screen_details.Cabin_Class = data.CABIN_CLASS;
      this.screen_details.Cancellation_Charge = data.CANCELLATION_CHARGE;
      this.screen_details.Band_Name = data.BAND_NAME;

    }
    //  else { //delete
    //   // this.editFlag = false;
    //   this.delete_id = data.BUCKET_ID;
    //   console.log(document.getElementById('deletebtn'),",delete:",data);
    //   (<HTMLButtonElement>document.getElementById('deletebtn')).click();
    // }

  }
 
  startrange() {
    let startrange = this.screen_details.Start_Range;
    var regex = /^[0-9]+$/;
    if (startrange != "" && regex.test(startrange) == false ) {
      this.startrangeflag = false;
      document.getElementById("startErr").innerHTML = " *Only Numbers are accepted"
    }

    else {
      this.startrangeflag = true;
      document.getElementById("startErr").innerHTML = ""
    }
    
  }
  endrange() {
    let endrange = this.screen_details.End_Range;
    // let endrange1=this.search_details.End_Range;
    var regex = /^[0-9]+$/;
    if (endrange != "" && regex.test(endrange) == false) {
      this.endrangeflag = false;
      document.getElementById("endErr").innerHTML = " *Only Numbers are accepted"
    }

    else {
      this.endrangeflag = true;
      document.getElementById("endErr").innerHTML = ""
    }

  }
  chargerange() {
    let charge = this.screen_details.Cancellation_Charge;
    // let endrange1=this.search_details.End_Range;
    var regex = /^[0-9]+$/;
    if (charge != "" && regex.test(charge) == false) {
      this.chargeflag = false;
      document.getElementById("chargeErr").innerHTML = " *Only Numbers are accepted"
    }

    else {
      this.chargeflag = true;
      document.getElementById("chargeErr").innerHTML = ""
    }

  }
  namecheck() {
    let name = this.screen_details.Band_Name;
    // let endrange1=this.search_details.End_Range;
    var regex = /^[\w ]+$/;
    if (name != "" && regex.test(name) == false) {
      this.nameflag = false;
      document.getElementById("nameErr").innerHTML = " *Please enter valid band name"
    }

    else {
      this.nameflag = true;
      document.getElementById("nameErr").innerHTML = ""
    }

  }
  deleteData(){
    var CANArray = {
      ID: this.delete_id
    };
    this.vernostService.DeleteCancelArray(CANArray).subscribe(response => {
      console.log("CancelDelete:-", response);
      if (response != undefined) {
        // document.getElementById("errs").innerHTML = 
        this.showMessagePopup("Record Deleted Successfully")
        this.screen_details = [];
      } else {
        // document.getElementById("errs").innerHTML = 
        this.showMessagePopup("Record Not Deleted Successfully")
      }

    });
  }
  showMessagePopup(msg){
    document.getElementById("errs").innerHTML = msg;
    setTimeout(()=>{
      document.getElementById("errs").innerHTML = "";
    },1000);
  }
}